import { EventTriggerType } from '../../../domain';
import PriceReferenceSelect from '../common/price-reference/PriceReferenceSelect';

interface Props {
  type: EventTriggerType;
  chainId: number;
}

function resolveChainIdentifier(type: EventTriggerType, chainId: number): string {
  if (type === EventTriggerType.SolanaTokenHolders) return '101';
  if (type === EventTriggerType.FogoTokenHolders) return '102';
  if (type === EventTriggerType.StellarTokenHolders) return '148';
  if (type === EventTriggerType.SuiTokenHolders) return 'sui';
  return String(chainId);
}

export default function TokenCurrencySelector({ type, chainId }: Props) {
  const chainIdentifier = resolveChainIdentifier(type, chainId);

  return (
    <PriceReferenceSelect
      chainIdentifier={chainIdentifier}
      fieldName="tokenCurrency"
      label="Price reference token"
      showCallout
      calloutTriggerType={type === EventTriggerType.OnChainSubgraphEvent ? 'subgraph' : 'token'}
    />
  );
}
